/** Footer interactions for the Twig footer component. */
import { openCookieSettings } from './utils/cookie-settings.js';

export function scrollToPageTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.querySelector('.js_footer_back_top')?.addEventListener('click', scrollToPageTop);

document.getElementById('js-footer-cookie-settings')?.addEventListener('click', function () {
  openCookieSettings(this.dataset.redirectUrl);
});
